// import { constantRoutes } from '@/router'
import { getProName, getProNo } from '@/utils/auth'
/**
 * 过滤路由
 * @param routes
 * @param roles
 * @returns {Array}
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.menuRole) {
    return roles.some(role => route.meta.menuRole.includes(role))
  } else {
    return true
  }
}

export function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      if (tmp.meta) {
        // tmp.meta.roles = roles
        if (tmp.meta.type === 1) {
          tmp.meta.proTitle = getProName() + ':' + getProNo()
        }
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  isProListView: false, // 是否为项目列表页面
  roles: [], // 权限
  asyncRoutes: [] // 项目列表路由
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.asyncRoutes = routes
  },
  SET_ROlES: (state, roles) => {
    state.roles = roles
  },
  SET_IS_PRO_LIST_VIEW: (state, isProListView) => {
    state.isProListView = isProListView
  }
}

const actions = {
  setAsyncRoutes({ commit, state }, routes) {
    return new Promise(resolve => {
      // const routesHandel = filterAsyncRoutes(routes, state.roles)
      // commit('SET_ROUTES', routesHandel)
      // resolve(routesHandel)
      commit('SET_ROUTES', routes)
      resolve(routes)
    })
  },
  getRolesByProId({ commit }, proId) {
    return new Promise(resolve => {
      const roles = []
      roles.push('AL-00')
      commit('SET_ROlES', roles)
      resolve(roles)
    })
  },
  setIsProListView({ commit }, isProListView) {
    return new Promise(resolve => {
      commit('SET_IS_PRO_LIST_VIEW', isProListView)
      resolve(isProListView)
    })
  },
  setRoles({ commit }, roles) {
    return new Promise(resolve => {
      commit('SET_ROlES', roles)
      resolve(roles)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
